module.exports = __webpack_public_path__ + "img/united-arab-emirates.b14dd0b7.svg";